import { render, staticRenderFns } from "./schoolSchedule.vue?vue&type=template&id=3449676c&"
import script from "./schoolSchedule.vue?vue&type=script&lang=js&"
export * from "./schoolSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports